module.exports = "\r\n.display-content{\r\n    background-color: #f3f3f3;\r\n    width: 100%;\r\n    height: 300px;\r\n    overflow-y: scroll;\r\n}\r\n.row{\r\n    padding :20px 0px 0px;\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/general-transaction/agent-transfer/agent-transfer-form/agent-transfer-form.component.css
// module id = ./src/app/general-transaction/agent-transfer/agent-transfer-form/agent-transfer-form.component.css
// module chunks = main